/*کسب و کار کوچک*/
import * as React from "react"

function SvgComponent(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={97.728}
      height={84.697}
      viewBox="0 0 97.728 84.697"
      {...props}
    >
      <g data-name="Group 333" fill="#c49a6c">
        <path
          data-name="Path 7532"
          d="M4.887 57.008h14.659V53.75a3.258 3.258 0 016.515 0v3.258h45.606V53.75a3.258 3.258 0 016.515 0v3.258h14.66a3.267 3.267 0 003.254-3.258V21.175a3.267 3.267 0 00-3.254-3.258H4.887a3.267 3.267 0 00-3.258 3.258v32.576a3.267 3.267 0 003.258 3.257z"
        />
        <path
          data-name="Path 7533"
          d="M78.187 63.523h-6.519v-6.515H26.061v6.515h-6.515v-6.515H4.887v22.8a3.267 3.267 0 003.258 3.258h81.442a3.267 3.267 0 003.258-3.258v-22.8H78.187v6.515z"
        />
      </g>
      <g data-name="Group 334" fill="#8b5e3c">
        <path
          data-name="Path 7534"
          d="M78.182 63.527v-9.773a3.258 3.258 0 00-6.515 0v9.773z"
        />
        <path
          data-name="Path 7535"
          d="M26.06 63.527v-9.773a3.258 3.258 0 10-6.515 0v9.773z"
        />
        <path
          data-name="Path 7536"
          d="M30.88 11.402a3.257 3.257 0 013.258-3.258h29.385a3.257 3.257 0 013.258 3.258l-.088 6.515h6.6v-6.515a9.772 9.772 0 00-9.773-9.773H34.205a9.772 9.772 0 00-9.773 9.773v6.515h6.515z"
        />
      </g>
      <path
        data-name="Path 7537"
        d="M92.841 16.288H74.925v-4.886a11.414 11.414 0 00-11.4-11.4H34.2a11.414 11.414 0 00-11.4 11.4v4.886H4.886A4.886 4.886 0 000 21.174V53.75a4.886 4.886 0 003.258 4.587v21.474a4.886 4.886 0 004.886 4.886h81.44a4.886 4.886 0 004.886-4.886V58.337a4.886 4.886 0 003.258-4.587V21.174a4.886 4.886 0 00-4.887-4.886zm-66.78-4.886A8.153 8.153 0 0134.2 3.257h29.323a8.153 8.153 0 018.144 8.144v4.886h-3.323l.065-4.886a4.9 4.9 0 00-4.886-4.886H34.144a4.9 4.9 0 00-4.886 4.886v.016l.044 4.87h-3.241v-4.885zm6.449 0a1.629 1.629 0 011.629-1.629h29.384a1.629 1.629 0 011.629 1.606l-.065 4.909H32.56zm58.7 68.409a1.629 1.629 0 01-1.629 1.629H8.144a1.629 1.629 0 01-1.629-1.629V58.637h11.4v4.886a1.629 1.629 0 001.629 1.629h6.515a1.629 1.629 0 001.629-1.629v-4.886h42.35v4.886a1.629 1.629 0 001.629 1.629h6.515a1.629 1.629 0 001.629-1.629v-4.886h11.4v21.174zM24.432 61.894h-3.258V53.75a1.593 1.593 0 01.5-1.16 1.549 1.549 0 011.129-.469 1.629 1.629 0 011.629 1.629zm52.122 0H73.3V53.75a1.629 1.629 0 011.629-1.629 1.649 1.649 0 011.629 1.629v8.144zM94.47 53.75a1.629 1.629 0 01-1.629 1.629h-13.03V53.75a4.886 4.886 0 00-9.773 0v1.629H27.69V53.75a4.886 4.886 0 00-9.773 0v1.629H4.886a1.629 1.629 0 01-1.629-1.629V21.174a1.629 1.629 0 011.629-1.628h87.955a1.629 1.629 0 011.629 1.629z"
        fill="#231f20"
      />
    </svg>
  )
}

const MemoSvgComponent = React.memo(SvgComponent)
export default MemoSvgComponent
